import { Injectable } from '@angular/core';
import { AuthTokenService } from '@kempoweroyj/ngx-auth-token-service';
export interface AppConfig {
    envName: 'dev' | 'prod' | 'test';

    /** API base url (without protocol and the /api suffix), e.g. kempower.io */
    apiBaseUrl: string;

    loginUrl: string;

    /** Authentication related settings */
    auth: {
        /** Auth0 domain e.g. kempower-dev.eu.auth0.com */
        domain: string;
        clientId: string;
        audience: string;
    };

    mapTilerApiKey?: string;

    /** Content CDN for product updates feed */
    contentCdn?: {
        url: string;
        deliveryToken: string;
        stage: string;
    };

    /** Sentry DSN */
    sentryDsn: string;

    /** Sentry replay sample rate for visualizing UI events in Sentry (0.0 - 1.0) */
    sentryReplaySampleRate: number;

    /** Sentry event sampling rate for sending non-UI events (0.0 - 1.0) */
    sentryTracesSampleRate: number;

    /**
     * Hostnames where this build is served (canonical + vanity) for this environment.
     * Trace headers to the API are only attached when the browser hostname matches
     * {@link apiBaseUrl}'s host; this list documents all entry points for operators and future checks.
     */
    browserHosts?: string[];

    /**
     * Tenants for which the tenant-level power graph on /fleet/map is hidden (no widget, no request).
     * Used for internal umbrella tenants (e.g. TESTING = all stations) whose whole-fleet on-demand
     * aggregation cannot be served within the API timeout and 502s. See KC-10655 / KC-10653.
     * Populated only in PROD configs; absent in dev/test so those environments are unaffected.
     */
    powerGraphHiddenTenants?: string[];
}

let AppConfig: AppConfig;

/** Called from main.ts which loads config from /config.json */
export function setCsmsAppConfig(appConfig: AppConfig) {
    AppConfig = appConfig;
}

@Injectable()
export class ConfigService {
    constructor(private authToken: AuthTokenService) {
        this.authToken.restApiUrl = this.restApiUrl;
    }

    get config(): AppConfig {
        return AppConfig;
    }

    get restApiUrl(): string {
        return `https://${this.config.apiBaseUrl}/api`;
    }

    get notificationsWebSocketUrl(): string {
        return `wss://${this.config.apiBaseUrl}/notifications`;
    }

    public readonly notificationsSendMessageAuditTimeMs: number = 2_000;
}
